var REFRESH = 'refresh';
var LOGOUT = 'logout';
var PROMPTCLOSE = 'promptclose';
var PAUSE = 'pause';
var RESUME = 'resume';
var HTTP_UNAUTHORIZED = 401;
var CALL_REFRESH = 'call-refresh';
var CALL_LOGOUT = 'call-logout';

export { CALL_LOGOUT, CALL_REFRESH, HTTP_UNAUTHORIZED, LOGOUT, PAUSE, PROMPTCLOSE, REFRESH, RESUME };
